import { CellContext } from '@tanstack/react-table'
import clsx from 'clsx'

import { UpdatedLog } from '@/types/logs'

import styles from './UpdatedRecordsTable.module.scss'

export const TripValue = ({ getValue, row, column }: CellContext<UpdatedLog, string | number | string[]>) => {
    const value = getValue()

    const displayedValue = Array.isArray(value) ? value.join(', ') : value
    const rtnTrips = row.original.rtnTrips.length ? `/${row.original.rtnTrips.map((trip) => trip.trip).join(',')}` : ''

    return (
        <div
            className={clsx(styles.updatedContainer, {
                [styles.updatedHighlighted]: row.original.propertiesChanged?.includes(column.id),
            })}
        >
            {displayedValue ? `${displayedValue}${rtnTrips}` : '-'}
        </div>
    )
}
